import {NgModule, APP_INITIALIZER} from "@angular/core";
import {LocationStrategy, HashLocationStrategy} from "@angular/common";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {PerfectScrollbarModule} from "ngx-perfect-scrollbar";
import {PerfectScrollbarConfigInterface} from "ngx-perfect-scrollbar";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

import {AppComponent} from "./app.component";

// Import routing module
import {AppRoutingModule} from "./app.routing";
import {ManualComponent} from "./pages/manual.component";

// Import 3rd party components
import {AuthEffects, AuthModule} from "@cosbeni/auth";
import {StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {TabsModule} from "ngx-bootstrap/tabs";
import {DragulaModule} from "ng2-dragula";
import {ChartsModule} from "ng2-charts";
import {ToasterModule} from "angular2-toaster/angular2-toaster";
import {DayPilotModule} from "daypilot-pro-angular";
import {FormHelperService} from "./services/form-helper.service";
import {AdminGuard} from "./services/admin.guard";
import {SystemAdminGuard} from "./services/system-admin.guard";
import {AuthGuard} from "./services/auth.guard";
import {ChangePasswordComponent} from "./pages/change-password.component";
import {LoginComponent} from "./pages/login.component";
import {ResetPasswordComponent} from "./pages/reset-password.component";
import * as wjcCore from "@grapecity/wijmo";
import * as fromLotas from "./ngrx/reducers/index";
import {DatabaseEffects, DatabaseService, DataService} from "@cosbeni/database";
import {LoadingService} from "./services/loading.service";
import {LoadingInterceptor} from "./services/loading.interceptor";
import {ConfigurationEffects, FiscalsEffects, UserEffects} from "./ngrx/effects";
import {SharedModule} from "./shared/shared.module";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

wjcCore.setLicenseKey("dev.lotas-system.info|lotas-system.info,835942938566117#B0YMdIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TP7VDMyZ4ci94RhlGU72WT784TwQWTrhldkRDaMx6QlhVRyUXaqZUO5ElQV3ERuxUZF3UWr5WaIFHcSdTaKJnVOxUWTJ6VyQ5VkhXMzVlW9AXOhh7M5UWVQdzRwFFV0l6TLVkRRVVWMlFRttkcYJ5SuRGUzglZqVXV53CcSZ4U5IzRohnVhNUdkZzL754LoxUbaJldyQzTahVeKJ5b5QzK8EENyN5LORmYQNmY0N6VKd7LatUaOhlNHpnZNlGSrInUrpUcINWe7VnNxJ7Qpl5ROZlTpFVc4EkeKRXdGhjZJl6bzondwAVY52kSVFmbU9WTpVnQhNTN9cmSRVUO5EVOuFTNJJGNiNkbxI7YKB5MLNnMvJ6NSVnUUJXMYF5VNxUQvJmVFJWV7omRRlETVd7QaV5VZJTYRJHe9o5U8IWbZZ7YiVnWUpkVG94YvATSZ3kbiRWMwpnaiojITJCLiQUMyMjR6MkMiojIIJCLxIDM8QjM6YzM0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiEjM4UjNwASOyQDM6IDMyIiOiQncDJCLi2mZulmLtVGdzl7ctMXY43Gbs2mZulmLtVGdzl7ctMXY43GbuYXZkJiOiMXbEJCLis8gjn9gjnrgjPrgj1LpnrJvk/IvlrKomLiOiEmTDJCLicTMxYjN5gzM9IDN9UzM8IiOiQWSiwSfdtlOicGbmJCLiI3dJI");

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AuthModule.forRoot({}),
        DayPilotModule,
        PerfectScrollbarModule,
        DragulaModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        ChartsModule,
        ToasterModule.forRoot(),
        StoreModule.forRoot({}, {
                runtimeChecks: {
                    strictStateImmutability: false,
                    strictActionImmutability: false,
                }
            }
        ),
        StoreModule.forFeature("lotasFeature", fromLotas.reducer),
        EffectsModule.forRoot([AuthEffects, DatabaseEffects, ConfigurationEffects, FiscalsEffects, UserEffects]),
        SharedModule
    ],
    declarations: [
        AppComponent,
        ChangePasswordComponent,
        LoginComponent,
        ManualComponent,
        ResetPasswordComponent
    ],
    providers: [{
        provide: LocationStrategy,
        useClass: HashLocationStrategy
    },
        {provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true},
        FormHelperService,
        AdminGuard,
        SystemAdminGuard,
        AuthGuard,
        DataService,
        DatabaseService,
        LoadingService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
